export const ACCESS_NO_END = "9999-12-31T23:59:59.999Z";

export function employeeAccess(employee) {
  return employee?.smartAssistanceSchedule || {
    enabled: employee?.smartAssistanceRounds?.enabled === true,
    opensAt: "1970-01-01T00:00:00.000Z",
    closesAt: ACCESS_NO_END,
  };
}

export function isEmployeeAccessActive(employee, now = Date.now()) {
  const access = employeeAccess(employee);
  return access.enabled === true && new Date(access.opensAt).getTime() <= now && now < new Date(access.closesAt).getTime();
}

export function employeeAccessUpdate(employee, access, selected = true) {
  return {
    smartAssistanceSchedule: access,
    smartAssistanceRounds: { ...employee?.smartAssistanceRounds, selected, enabled: isEmployeeAccessActive({ smartAssistanceSchedule: access }) },
  };
}
